import type { InferOutput } from "valibot";

export const autocompleteSchema = v.object({
  results: v.array(productDocumentSchema),
});
export type Autocomplete = InferOutput<typeof autocompleteSchema>;
